var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAccountFaq = function SvgIconAccountFaq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 15.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12m-.75-3.75h1.5v1.5h-1.5zm1.5-1.234V9.5h-1.5V8.375a.75.75 0 0 1 .75-.75 1.125 1.125 0 1 0-1.103-1.346l-1.472-.294A2.626 2.626 0 1 1 8.75 9.016"
  })));
};
export default SvgIconAccountFaq;